import { cfgEn, cfgEs, cfgPt } from './config-crm-i18n';
import { ficha2En, ficha2Es, ficha2Pt } from './crm2-ficha-i18n';
import { crm6En, crm6Es, crm6Pt } from './crm6-i18n';
import { cascaEn, cascaEs, cascaPt, crmEn, crmEs, crmPt } from './crm-i18n';
import { questEn, questEs, questPt } from './questionario-i18n';
import { copiaEn, copiaEs, copiaPt } from './negociacao-copia-i18n';
import { excluidasEn, excluidasEs, excluidasPt } from './tarefas-excluidas-i18n';
import { relatorioEn, relatorioEs, relatorioPt } from './relatorio-i18n';
import { relatoriosEn, relatoriosEs, relatoriosPt } from './relatorios-crm-i18n';

const pt = {
  nome: 'Pipeline',
  buscaGlobal: { atividades: 'Atividades' },
  // CRM no novo desenho (lotes 2 a 5): páginas da casca nova e textos do CRM do clone do RD.
  casca: cascaPt,
  abas: { pipeline: 'Pipeline', equipes: 'Equipes', metas: 'Metas', 'motivos-perda': 'Motivos de perda', atividades: 'Atividades' },
  indicadores: { oportunidades_abertas: 'Oportunidades em negociação' },
  acoes: {
    novaOportunidade: 'Nova oportunidade', ganhar: 'Marcar ganha', perder: 'Marcar perdida', agendar: 'Agendar atividade', concluir: 'Concluir', cancelar: 'Cancelar',
    novaEquipe: 'Nova equipe', novaMeta: 'Nova meta', novoMotivo: 'Novo motivo', adicionar: 'Adicionar', editar: 'Editar', confirmarGanho: 'Confirmar ganho', confirmarPerda: 'Confirmar perda',
    minhas: 'Só as minhas', todas: 'Todas',
  },
  campos: {
    agendamento: 'agendamento', titulo: 'Título', parceiro: 'Cliente', valor: 'Valor', responsavel: 'Responsável', equipe: 'Equipe', etapa: 'Etapa', probabilidade: 'Probabilidade (%)', origem: 'Origem',
    canal: 'Canal', utmFonte: 'UTM fonte', utmMidia: 'UTM mídia', utmCampanha: 'UTM campanha', previsao: 'Previsão de fechamento', moeda: 'Moeda', moedaComItens: 'Com itens, a moeda não muda: para trocar, tire os itens antes.', regimePretendido: 'Regime tributário pretendido', regimePretendidoAjuda: 'Sugerido pelo regime atual da empresa. Vazio, vale o regime em vigor dela.', indicadoPor: 'Indicado por', motivo: 'Motivo da perda', observacao: 'Observação',
    projeto: 'Projeto', criadaEm: 'Criada em', ganhaEm: 'Ganha em', perdidaEm: 'Perdida em', nome: 'Nome', membros: 'Membros', mes: 'Mês', alvo: 'Alvo', vendedor: 'Vendedor',
    tipo: 'Tipo', dataHora: 'Data e hora', situacao: 'Situação', oportunidade: 'Oportunidade', recurso: 'Recurso da agenda', servico: 'Serviço da agenda', projetoNome: 'Nome do projeto',
    converter: 'Converter em projeto', meta: 'Meta', realizado: 'Realizado', abertas: 'Abertas', emNegociacao: 'Em negociação', perdidas: 'Perdidas', ganhas: 'Ganhas',
  },
  estado: { aberta: 'Aberta', ganha: 'Ganha', perdida: 'Perdida' },
  etapaTipo: { aberta: 'Aberta', ganha: 'Ganha', perdida: 'Perdida' },
  tipoAtividade: { tarefa: 'Tarefa', ligacao: 'Ligação', reuniao: 'Reunião', follow_up: 'Follow-up', email: 'E-mail', whatsapp: 'WhatsApp', visita: 'Visita', almoco: 'Almoço' },
  estadoAtividade: { pendente: 'Pendente', concluida: 'Concluída', cancelada: 'Cancelada' },
  filtroAtividade: { pendentes: 'Pendentes', atrasadas: 'Atrasadas', concluidas: 'Concluídas', todas: 'Todas' },
  metricas: {
    valorEmNegociacao: 'Valor em negociação', ponderado: 'Ponderado pela probabilidade: {{valor}}', abertas: 'Oportunidades abertas', cicloMedio: 'Ciclo médio', dias_one: '{{valor}} dia', dias_other: '{{valor}} dias',
    semCiclo: 'Sem ganhas ainda', conversao: 'Conversão por etapa', conversaoTexto: '{{avancaram}} de {{entraram}} seguiram adiante', semDados: 'Sem dados ainda',
  },
  quadro: { totalColuna: '{{n}} no total', exibindo: 'Mostrando {{n}}', exibindoRecentes: 'Mostrando {{n}} (encerradas dos últimos 30 dias)', truncado: 'Há mais cartões do que o quadro comporta: mostrando {{exibidos}} de {{total}}. Os totais das etapas são reais; use os filtros para ver o restante.', vazio: 'Nenhuma venda em andamento ainda. Registre a primeira oportunidade.', soltar: 'Arraste o cartão para outra etapa', atrasadas_one: '{{count}} atrasada', atrasadas_other: '{{count}} atrasadas', pendentes_one: '{{count}} pendente', pendentes_other: '{{count}} pendentes', semResponsavel: 'Sem responsável' },
  leadRapido: {
    titulo: 'Novo lead pelo CNPJ',
    chamada: 'Cliente novo? Crie o lead pelo CNPJ sem sair daqui.',
    explicacao: 'Digite o CNPJ: a consulta da Receita preenche os dados. O lead entra no Cadastros e vira cliente sozinho quando a oportunidade for ganha.',
    cnpj: 'CNPJ',
    cnpjAjuda: 'Com o CNPJ completo, a consulta preenche nome, e-mail, telefone, endereço e dados fiscais.',
    nome: 'Nome ou razão social',
    email: 'E-mail',
    telefone: 'Telefone',
    salvar: 'Criar lead e usar',
    criado: 'Lead criado',
    usarExistente: 'Usar o cadastro existente',
    consulta: { buscando: 'Consultando o CNPJ…', preenchido: 'Dados da Receita preenchidos', naoEncontrado: 'CNPJ não encontrado na Receita', falha: 'Consulta indisponível agora; preencha à mão', desligada: 'Consulta de CNPJ desligada no workspace' },
  },
  itens: {
    titulo: 'Itens da proposta',
    ajuda: 'O valor da oportunidade passa a ser a soma dos itens. Cada item tem a sua recorrência; no ganho, nasce um contrato por vertical com todos os itens dela (a implantação avulsa entra só na primeira fatura; a mensalidade, em todas).',
    vazio: 'Sem itens: o valor digitado vale como antes.',
    valorPelosItens: 'Soma dos itens da proposta: para mudar o valor, mude os itens.',
    servico: 'Serviço',
    semServico: 'Sem serviço do catálogo',
    vertical: 'Vertical',
    descricao: 'Descrição do item {{n}}',
    quantidade: 'Quantidade',
    preco: 'Preço unitário',
    total: 'Total',
    remover: 'Remover item',
    adicionar: 'Adicionar item',
    salvar: 'Salvar itens',
    salvos: 'Itens salvos',
    incompleto: 'Preencha descrição, quantidade e preço de cada item',
    recorrenciaCampo: 'Recorrência',
    recorrencia: { mensal: 'Mensal', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual', avulso: 'Avulso (uma vez)' },
  },
  drawer: { atividades: 'Atividades', nenhumaAtividade: 'Nenhuma atividade agendada', encerrada: 'Oportunidade encerrada: os dados não podem mais ser editados.', mover: 'Mover para a etapa', agendamento: 'Agendada na Agenda', projetoCriado: 'Criado a partir desta oportunidade' },
  modal: {
    ganharTitulo: 'Marcar como ganha', ganharTexto: 'A oportunidade vai para a etapa de ganho e sai do valor em negociação.', converterTexto: 'Cria um projeto para o cliente com o valor da oportunidade.',
    perderTitulo: 'Marcar como perdida', perderTexto: 'Escolha o motivo. Ele alimenta o relatório de perdas.', semMotivos: 'Cadastre motivos na aba Motivos de perda.',
    agendarTitulo: 'Agendar atividade', equipeTitulo: 'Equipe', metaTitulo: 'Meta mensal', motivoTitulo: 'Motivo de perda',
  },
  equipes: { vazio: 'Crie uma equipe de vendas e escolha os membros.', abertas_one: '{{count}} aberta', abertas_other: '{{count}} abertas', valor: 'Em negociação: {{valor}}', semMembros: 'Sem membros' },
  metas: { vazio: 'Nenhuma meta para este mês. Defina a meta de uma equipe ou de um vendedor.', total: 'Total do mês', equipe: 'Equipe', vendedor: 'Vendedor', percentual: '{{n}}% da meta', semMeta: 'Meta zerada' },
  motivos: { vazio: 'Cadastre os motivos de perda que a equipe usa.', perdidas_one: '{{count}} perdida', perdidas_other: '{{count}} perdidas', confirmarRemover: 'Remover este motivo?', confirmarTexto: 'Ele sai da lista de escolha. As oportunidades já perdidas guardam o motivo.' },
  atividades: { vazio: 'Nenhuma atividade neste filtro.', atrasada: 'Atrasada', abrir: 'Abrir oportunidade', seloMenu_one: '{{count}} tarefa sua atrasada', seloMenu_other: '{{count}} tarefas suas atrasadas' },
  confirmar: { excluir: 'Excluir?', excluirEquipe: 'Excluir esta equipe? As metas dela também saem.', cancelarAtividade: 'Cancelar esta atividade?' },
  erros: { carregar: 'Não foi possível carregar o pipeline' },
  // CRM novo desenho: páginas do CRM (lotes 2 a 5, `crm-i18n.ts`), busca global (N8) e Copiloto simulado (N9) do lote 6.
  crm: {
    ...crmPt,
    ficha2: ficha2Pt,
    copia: copiaPt,
    excluidas: excluidasPt,
    cfg: cfgPt,
    crm6: crm6Pt,
    quest: questPt,
    relatorio: relatorioPt,
    relatorios: relatoriosPt,
    buscaNegociacoes: 'Negociações',
    copiloto: {
      etapas: 'Quantas negociações estão em andamento em cada etapa do funil?',
      etapasResposta_one: 'No funil {{funil}}, há {{count}} negociação em andamento:',
      etapasResposta_other: 'No funil {{funil}}, há {{count}} negociações em andamento:',
      abrirQuadro: 'Abrir o Comercial',
      resultado: 'Quantas negociações foram criadas, vendidas e perdidas?',
      resultadoResposta: 'Resumo das negociações:',
      criadas: 'Criadas',
      emAndamento: 'Em andamento',
      vendidas: 'Vendidas',
      perdidas: 'Perdidas',
      equipe: 'Qual é o desempenho de cada pessoa da equipe de vendas?',
      equipeResposta: 'Negociações por responsável:',
      equipeLinha: '{{total}} negociações, {{ganhas}} vendidas ({{valor}})',
      semResponsavel: 'Sem responsável',
      perdas: 'Em quais etapas do funil estamos perdendo mais negociações?',
      perdasResposta_one: '{{count}} negociação perdida, pela etapa em que estava:',
      perdasResposta_other: '{{count}} negociações perdidas, pela etapa em que estavam:',
      perdidasN_one: '{{count}} perdida',
      perdidasN_other: '{{count}} perdidas',
      semPerdas: 'Nenhuma negociação perdida até agora.',
      origem: 'Qual origem teve a maior taxa de conversão?',
      origemResposta: 'A origem com a maior taxa de venda é {{origem}}:',
      origemLinha_one: '{{taxa}} de {{count}} negociação',
      origemLinha_other: '{{taxa}} de {{count}} negociações',
      semDados: 'Ainda não há negociações para analisar.',
      funis: 'Como eu crio e edito meus funis de vendas?',
      funisResposta: 'Em CRM > Configurações do CRM > Funis de vendas, use "Criar e organizar funis": crie um funil novo (ele começa com as etapas do funil escolhido), arquive ou desarquive, e ajuste as etapas e o playbook de cada uma.',
      abrirFunis: 'Abrir os funis de vendas',
      motivos: 'Onde cadastro os motivos de perda?',
      motivosResposta: 'Em CRM > Configurações do CRM > Motivos de perda. Eles aparecem ao marcar uma negociação como perdida.',
      abrirMotivos: 'Abrir os motivos de perda',
    },
  },
  funis: {
    funil: 'Funil',
    gerir: 'Funis',
    titulo: 'Funis do pipeline',
    ajuda: 'Cada funil tem as próprias etapas. O funil novo começa com as etapas do funil escolhido; renomeie, crie e exclua etapas em Admin > Configurações > Etapas e funções e mude a ordem arrastando as colunas no quadro.',
    nomeNovo: 'Nome do funil novo',
    copiarDe: 'Etapas de',
    criar: 'Criar funil',
    vazio: 'Nenhum funil ainda.',
    vazioQuadro: 'Ainda não há funil de vendas. Crie o primeiro para registrar oportunidades.',
    padrao: 'Padrão',
    arquivado: 'Arquivado',
    arquivar: 'Arquivar',
    desarquivar: 'Desarquivar',
    etapas_one: '{{count}} etapa',
    etapas_other: '{{count}} etapas',
    abertas_one: '{{count}} aberta',
    abertas_other: '{{count}} abertas',
    confirmarArquivar: 'Arquivar este funil?',
    confirmarArquivarTexto: 'Ele sai da escolha de funil e não recebe oportunidades novas. As encerradas continuam nos relatórios; desarquive quando quiser.',
  },
};

type Dic = typeof pt;

const en: Dic = {
  nome: 'Pipeline',
  buscaGlobal: { atividades: 'Activities' },
  casca: cascaEn,
  abas: { pipeline: 'Pipeline', equipes: 'Teams', metas: 'Targets', 'motivos-perda': 'Loss reasons', atividades: 'Activities' },
  indicadores: { oportunidades_abertas: 'Open pipeline value' },
  acoes: {
    novaOportunidade: 'New opportunity', ganhar: 'Mark as won', perder: 'Mark as lost', agendar: 'Schedule activity', concluir: 'Complete', cancelar: 'Cancel',
    novaEquipe: 'New team', novaMeta: 'New target', novoMotivo: 'New reason', adicionar: 'Add', editar: 'Edit', confirmarGanho: 'Confirm win', confirmarPerda: 'Confirm loss',
    minhas: 'Mine only', todas: 'All',
  },
  campos: {
    agendamento: 'appointment', titulo: 'Title', parceiro: 'Customer', valor: 'Value', responsavel: 'Owner', equipe: 'Team', etapa: 'Stage', probabilidade: 'Probability (%)', origem: 'Source',
    canal: 'Channel', utmFonte: 'UTM source', utmMidia: 'UTM medium', utmCampanha: 'UTM campaign', previsao: 'Expected close', moeda: 'Currency', moedaComItens: 'With items, the currency does not change: remove the items first to switch it.', regimePretendido: 'Intended tax regime', regimePretendidoAjuda: 'Suggested from the company\'s current regime. Left empty, its regime in force applies.', indicadoPor: 'Referred by', motivo: 'Loss reason', observacao: 'Note',
    projeto: 'Project', criadaEm: 'Created at', ganhaEm: 'Won at', perdidaEm: 'Lost at', nome: 'Name', membros: 'Members', mes: 'Month', alvo: 'Target for', vendedor: 'Salesperson',
    tipo: 'Type', dataHora: 'Date and time', situacao: 'Status', oportunidade: 'Opportunity', recurso: 'Calendar resource', servico: 'Calendar service', projetoNome: 'Project name',
    converter: 'Convert to project', meta: 'Target', realizado: 'Achieved', abertas: 'Open', emNegociacao: 'In negotiation', perdidas: 'Lost', ganhas: 'Won',
  },
  estado: { aberta: 'Open', ganha: 'Won', perdida: 'Lost' },
  etapaTipo: { aberta: 'Open', ganha: 'Won', perdida: 'Lost' },
  tipoAtividade: { tarefa: 'Task', ligacao: 'Call', reuniao: 'Meeting', follow_up: 'Follow-up', email: 'Email', whatsapp: 'WhatsApp', visita: 'Visit', almoco: 'Lunch' },
  estadoAtividade: { pendente: 'Pending', concluida: 'Completed', cancelada: 'Canceled' },
  filtroAtividade: { pendentes: 'Pending', atrasadas: 'Overdue', concluidas: 'Completed', todas: 'All' },
  metricas: {
    valorEmNegociacao: 'Pipeline value', ponderado: 'Weighted by probability: {{valor}}', abertas: 'Open opportunities', cicloMedio: 'Average cycle', dias_one: '{{valor}} day', dias_other: '{{valor}} days',
    semCiclo: 'No wins yet', conversao: 'Conversion by stage', conversaoTexto: '{{avancaram}} of {{entraram}} moved forward', semDados: 'No data yet',
  },
  quadro: { totalColuna: '{{n}} in total', exibindo: 'Showing {{n}}', exibindoRecentes: 'Showing {{n}} (closed in the last 30 days)', truncado: 'There are more cards than the board can hold: showing {{exibidos}} of {{total}}. Stage totals are real; use the filters to see the rest.', vazio: 'No deals in progress yet. Add the first opportunity.', soltar: 'Drag the card to another stage', atrasadas_one: '{{count}} overdue', atrasadas_other: '{{count}} overdue', pendentes_one: '{{count}} pending', pendentes_other: '{{count}} pending', semResponsavel: 'No owner' },
  leadRapido: {
    titulo: 'New lead by CNPJ',
    chamada: 'New customer? Create the lead by CNPJ without leaving this form.',
    explicacao: 'Type the CNPJ: the Federal Revenue lookup fills in the details. The lead goes into Records and becomes a customer automatically when the opportunity is won.',
    cnpj: 'CNPJ',
    cnpjAjuda: 'With the full CNPJ, the lookup fills in name, email, phone, address and tax data.',
    nome: 'Name or company name',
    email: 'Email',
    telefone: 'Phone',
    salvar: 'Create lead and use',
    criado: 'Lead created',
    usarExistente: 'Use the existing record',
    consulta: { buscando: 'Looking up the CNPJ…', preenchido: 'Federal Revenue data filled in', naoEncontrado: 'CNPJ not found at the Federal Revenue', falha: 'Lookup unavailable now; fill in by hand', desligada: 'CNPJ lookup is turned off in the workspace' },
  },
  itens: {
    titulo: 'Proposal items',
    ajuda: 'The opportunity value becomes the sum of the items. Each item has its own recurrence; when won, one contract is created per vertical with all its items (the one-off setup goes only on the first invoice; the monthly fee, on all of them).',
    vazio: 'No items: the typed value stays as before.',
    valorPelosItens: 'Sum of the proposal items: to change the value, change the items.',
    servico: 'Service',
    semServico: 'No catalog service',
    vertical: 'Business unit',
    descricao: 'Item {{n}} description',
    quantidade: 'Quantity',
    preco: 'Unit price',
    total: 'Total',
    remover: 'Remove item',
    adicionar: 'Add item',
    salvar: 'Save items',
    salvos: 'Items saved',
    incompleto: 'Fill in the description, quantity and price of each item',
    recorrenciaCampo: 'Recurrence',
    recorrencia: { mensal: 'Monthly', trimestral: 'Quarterly', semestral: 'Every six months', anual: 'Yearly', avulso: 'One-off' },
  },
  drawer: { atividades: 'Activities', nenhumaAtividade: 'No activity scheduled', encerrada: 'Closed opportunity: the data can no longer be edited.', mover: 'Move to stage', agendamento: 'Booked in Calendar', projetoCriado: 'Created from this opportunity' },
  modal: {
    ganharTitulo: 'Mark as won', ganharTexto: 'The opportunity moves to the won stage and leaves the pipeline value.', converterTexto: 'Creates a project for the customer with the opportunity value.',
    perderTitulo: 'Mark as lost', perderTexto: 'Choose the reason. It feeds the loss report.', semMotivos: 'Add reasons in the Loss reasons tab.',
    agendarTitulo: 'Schedule activity', equipeTitulo: 'Team', metaTitulo: 'Monthly target', motivoTitulo: 'Loss reason',
  },
  equipes: { vazio: 'Create a sales team and choose its members.', abertas_one: '{{count}} open', abertas_other: '{{count}} open', valor: 'In negotiation: {{valor}}', semMembros: 'No members' },
  metas: { vazio: 'No targets for this month. Set a team or salesperson target.', total: 'Month total', equipe: 'Team', vendedor: 'Salesperson', percentual: '{{n}}% of target', semMeta: 'Zero target' },
  motivos: { vazio: 'Add the loss reasons your team uses.', perdidas_one: '{{count}} lost', perdidas_other: '{{count}} lost', confirmarRemover: 'Remove this reason?', confirmarTexto: 'It leaves the choice list. Opportunities already lost keep the reason.' },
  atividades: { vazio: 'No activities in this filter.', atrasada: 'Overdue', abrir: 'Open opportunity', seloMenu_one: '{{count}} of your tasks is overdue', seloMenu_other: '{{count}} of your tasks are overdue' },
  confirmar: { excluir: 'Delete?', excluirEquipe: 'Delete this team? Its targets are removed too.', cancelarAtividade: 'Cancel this activity?' },
  erros: { carregar: 'Could not load the pipeline' },
  // CRM new design, batch 6: global search (N8) and Copilot with simulated answers (N9).
  crm: {
    ...crmEn,
    ficha2: ficha2En,
    copia: copiaEn,
    excluidas: excluidasEn,
    cfg: cfgEn,
    crm6: crm6En,
    quest: questEn,
    relatorio: relatorioEn,
    relatorios: relatoriosEn,
    buscaNegociacoes: 'Deals',
    copiloto: {
      etapas: 'How many deals are in progress in each pipeline stage?',
      etapasResposta_one: 'In the {{funil}} pipeline, {{count}} deal is in progress:',
      etapasResposta_other: 'In the {{funil}} pipeline, {{count}} deals are in progress:',
      abrirQuadro: 'Open Sales',
      resultado: 'How many deals were created, won and lost?',
      resultadoResposta: 'Deals summary:',
      criadas: 'Created',
      emAndamento: 'In progress',
      vendidas: 'Won',
      perdidas: 'Lost',
      equipe: 'How is each person on the sales team performing?',
      equipeResposta: 'Deals by owner:',
      equipeLinha: '{{total}} deals, {{ganhas}} won ({{valor}})',
      semResponsavel: 'No owner',
      perdas: 'In which pipeline stages are we losing the most deals?',
      perdasResposta_one: '{{count}} lost deal, by the stage it was in:',
      perdasResposta_other: '{{count}} lost deals, by the stage they were in:',
      perdidasN_one: '{{count}} lost',
      perdidasN_other: '{{count}} lost',
      semPerdas: 'No lost deals so far.',
      origem: 'Which source had the highest conversion rate?',
      origemResposta: 'The source with the highest win rate is {{origem}}:',
      origemLinha_one: '{{taxa}} of {{count}} deal',
      origemLinha_other: '{{taxa}} of {{count}} deals',
      semDados: 'There are no deals to analyze yet.',
      funis: 'How do I create and edit my sales pipelines?',
      funisResposta: 'In CRM > CRM settings > Sales pipelines, use "Create and organize pipelines": create a new pipeline (it starts with the stages of the chosen one), archive or unarchive it, and adjust the stages and the playbook of each one.',
      abrirFunis: 'Open sales pipelines',
      motivos: 'Where do I set up loss reasons?',
      motivosResposta: 'In CRM > CRM settings > Loss reasons. They show up when you mark a deal as lost.',
      abrirMotivos: 'Open loss reasons',
    },
  },
  funis: {
    funil: 'Pipeline',
    gerir: 'Pipelines',
    titulo: 'Pipelines',
    ajuda: 'Each pipeline has its own stages. A new pipeline starts with the stages of the chosen one; rename, create and delete stages in Admin > Settings > Stages and roles and change the order by dragging the columns on the board.',
    nomeNovo: 'New pipeline name',
    copiarDe: 'Stages from',
    criar: 'Create pipeline',
    vazio: 'No pipelines yet.',
    vazioQuadro: 'There is no sales pipeline yet. Create the first one to add opportunities.',
    padrao: 'Default',
    arquivado: 'Archived',
    arquivar: 'Archive',
    desarquivar: 'Unarchive',
    etapas_one: '{{count}} stage',
    etapas_other: '{{count}} stages',
    abertas_one: '{{count}} open',
    abertas_other: '{{count}} open',
    confirmarArquivar: 'Archive this pipeline?',
    confirmarArquivarTexto: 'It leaves the pipeline choice and takes no new opportunities. Closed ones stay in the reports; unarchive it whenever you want.',
  },
};

const es: Dic = {
  nome: 'Pipeline',
  buscaGlobal: { atividades: 'Actividades' },
  casca: cascaEs,
  abas: { pipeline: 'Pipeline', equipes: 'Equipos', metas: 'Metas', 'motivos-perda': 'Motivos de pérdida', atividades: 'Actividades' },
  indicadores: { oportunidades_abertas: 'Oportunidades en negociación' },
  acoes: {
    novaOportunidade: 'Nueva oportunidad', ganhar: 'Marcar como ganada', perder: 'Marcar como perdida', agendar: 'Programar actividad', concluir: 'Completar', cancelar: 'Cancelar',
    novaEquipe: 'Nuevo equipo', novaMeta: 'Nueva meta', novoMotivo: 'Nuevo motivo', adicionar: 'Agregar', editar: 'Editar', confirmarGanho: 'Confirmar ganancia', confirmarPerda: 'Confirmar pérdida',
    minhas: 'Solo las mías', todas: 'Todas',
  },
  campos: {
    agendamento: 'cita', titulo: 'Título', parceiro: 'Cliente', valor: 'Valor', responsavel: 'Responsable', equipe: 'Equipo', etapa: 'Etapa', probabilidade: 'Probabilidad (%)', origem: 'Origen',
    canal: 'Canal', utmFonte: 'UTM fuente', utmMidia: 'UTM medio', utmCampanha: 'UTM campaña', previsao: 'Cierre previsto', moeda: 'Moneda', moedaComItens: 'Con ítems, la moneda no cambia: para cambiarla, quita los ítems antes.', regimePretendido: 'Régimen tributario previsto', regimePretendidoAjuda: 'Sugerido por el régimen actual de la empresa. Vacío, vale su régimen vigente.', indicadoPor: 'Recomendado por', motivo: 'Motivo de la pérdida', observacao: 'Observación',
    projeto: 'Proyecto', criadaEm: 'Creada el', ganhaEm: 'Ganada el', perdidaEm: 'Perdida el', nome: 'Nombre', membros: 'Miembros', mes: 'Mes', alvo: 'Meta de', vendedor: 'Vendedor',
    tipo: 'Tipo', dataHora: 'Fecha y hora', situacao: 'Situación', oportunidade: 'Oportunidad', recurso: 'Recurso de la agenda', servico: 'Servicio de la agenda', projetoNome: 'Nombre del proyecto',
    converter: 'Convertir en proyecto', meta: 'Meta', realizado: 'Logrado', abertas: 'Abiertas', emNegociacao: 'En negociación', perdidas: 'Perdidas', ganhas: 'Ganadas',
  },
  estado: { aberta: 'Abierta', ganha: 'Ganada', perdida: 'Perdida' },
  etapaTipo: { aberta: 'Abierta', ganha: 'Ganada', perdida: 'Perdida' },
  tipoAtividade: { tarefa: 'Tarea', ligacao: 'Llamada', reuniao: 'Reunión', follow_up: 'Seguimiento', email: 'Correo', whatsapp: 'WhatsApp', visita: 'Visita', almoco: 'Almuerzo' },
  estadoAtividade: { pendente: 'Pendiente', concluida: 'Completada', cancelada: 'Cancelada' },
  filtroAtividade: { pendentes: 'Pendientes', atrasadas: 'Atrasadas', concluidas: 'Completadas', todas: 'Todas' },
  metricas: {
    valorEmNegociacao: 'Valor en negociación', ponderado: 'Ponderado por probabilidad: {{valor}}', abertas: 'Oportunidades abiertas', cicloMedio: 'Ciclo promedio', dias_one: '{{valor}} día', dias_other: '{{valor}} días',
    semCiclo: 'Aún sin ganadas', conversao: 'Conversión por etapa', conversaoTexto: '{{avancaram}} de {{entraram}} avanzaron', semDados: 'Aún sin datos',
  },
  quadro: { totalColuna: '{{n}} en total', exibindo: 'Mostrando {{n}}', exibindoRecentes: 'Mostrando {{n}} (cerradas en los últimos 30 días)', truncado: 'Hay más tarjetas de las que el tablero admite: mostrando {{exibidos}} de {{total}}. Los totales de las etapas son reales; usa los filtros para ver el resto.', vazio: 'Aún no hay ventas en curso. Registra la primera oportunidad.', soltar: 'Arrastra la tarjeta a otra etapa', atrasadas_one: '{{count}} atrasada', atrasadas_other: '{{count}} atrasadas', pendentes_one: '{{count}} pendiente', pendentes_other: '{{count}} pendientes', semResponsavel: 'Sin responsable' },
  leadRapido: {
    titulo: 'Nuevo lead por CNPJ',
    chamada: '¿Cliente nuevo? Crea el lead por CNPJ sin salir de aquí.',
    explicacao: 'Escribe el CNPJ: la consulta de la Receita completa los datos. El lead entra en Registros y pasa a cliente solo cuando la oportunidad se gana.',
    cnpj: 'CNPJ',
    cnpjAjuda: 'Con el CNPJ completo, la consulta completa nombre, correo, teléfono, dirección y datos fiscales.',
    nome: 'Nombre o razón social',
    email: 'Correo',
    telefone: 'Teléfono',
    salvar: 'Crear lead y usar',
    criado: 'Lead creado',
    usarExistente: 'Usar el registro existente',
    consulta: { buscando: 'Consultando el CNPJ…', preenchido: 'Datos de la Receita completados', naoEncontrado: 'CNPJ no encontrado en la Receita', falha: 'Consulta no disponible ahora; complétalo a mano', desligada: 'La consulta de CNPJ está desactivada en el espacio de trabajo' },
  },
  itens: {
    titulo: 'Ítems de la propuesta',
    ajuda: 'El valor de la oportunidad pasa a ser la suma de los ítems. Cada ítem tiene su recurrencia; al ganarla, nace un contrato por vertical con todos sus ítems (la implantación puntual entra solo en la primera factura; la mensualidad, en todas).',
    vazio: 'Sin ítems: el valor escrito vale como antes.',
    valorPelosItens: 'Suma de los ítems de la propuesta: para cambiar el valor, cambia los ítems.',
    servico: 'Servicio',
    semServico: 'Sin servicio del catálogo',
    vertical: 'Vertical',
    descricao: 'Descripción del ítem {{n}}',
    quantidade: 'Cantidad',
    preco: 'Precio unitario',
    total: 'Total',
    remover: 'Quitar ítem',
    adicionar: 'Agregar ítem',
    salvar: 'Guardar ítems',
    salvos: 'Ítems guardados',
    incompleto: 'Completa la descripción, la cantidad y el precio de cada ítem',
    recorrenciaCampo: 'Recurrencia',
    recorrencia: { mensal: 'Mensual', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual', avulso: 'Única (una vez)' },
  },
  drawer: { atividades: 'Actividades', nenhumaAtividade: 'Ninguna actividad programada', encerrada: 'Oportunidad cerrada: los datos ya no se pueden editar.', mover: 'Mover a la etapa', agendamento: 'Reservada en la Agenda', projetoCriado: 'Creado a partir de esta oportunidad' },
  modal: {
    ganharTitulo: 'Marcar como ganada', ganharTexto: 'La oportunidad pasa a la etapa de ganancia y sale del valor en negociación.', converterTexto: 'Crea un proyecto para el cliente con el valor de la oportunidad.',
    perderTitulo: 'Marcar como perdida', perderTexto: 'Elige el motivo. Alimenta el informe de pérdidas.', semMotivos: 'Registra motivos en la pestaña Motivos de pérdida.',
    agendarTitulo: 'Programar actividad', equipeTitulo: 'Equipo', metaTitulo: 'Meta mensual', motivoTitulo: 'Motivo de pérdida',
  },
  equipes: { vazio: 'Crea un equipo de ventas y elige a los miembros.', abertas_one: '{{count}} abierta', abertas_other: '{{count}} abiertas', valor: 'En negociación: {{valor}}', semMembros: 'Sin miembros' },
  metas: { vazio: 'Ninguna meta para este mes. Define la meta de un equipo o de un vendedor.', total: 'Total del mes', equipe: 'Equipo', vendedor: 'Vendedor', percentual: '{{n}}% de la meta', semMeta: 'Meta en cero' },
  motivos: { vazio: 'Registra los motivos de pérdida que usa el equipo.', perdidas_one: '{{count}} perdida', perdidas_other: '{{count}} perdidas', confirmarRemover: '¿Eliminar este motivo?', confirmarTexto: 'Sale de la lista de elección. Las oportunidades ya perdidas conservan el motivo.' },
  atividades: { vazio: 'Ninguna actividad en este filtro.', atrasada: 'Atrasada', abrir: 'Abrir oportunidad', seloMenu_one: '{{count}} tarea tuya atrasada', seloMenu_other: '{{count}} tareas tuyas atrasadas' },
  confirmar: { excluir: '¿Eliminar?', excluirEquipe: '¿Eliminar este equipo? Sus metas también salen.', cancelarAtividade: '¿Cancelar esta actividad?' },
  erros: { carregar: 'No se pudo cargar el pipeline' },
  // CRM nuevo diseño, lote 6: búsqueda global (N8) y Copiloto con respuestas simuladas (N9).
  crm: {
    ...crmEs,
    ficha2: ficha2Es,
    copia: copiaEs,
    excluidas: excluidasEs,
    cfg: cfgEs,
    crm6: crm6Es,
    quest: questEs,
    relatorio: relatorioEs,
    relatorios: relatoriosEs,
    buscaNegociacoes: 'Negociaciones',
    copiloto: {
      etapas: '¿Cuántas negociaciones están en curso en cada etapa del embudo?',
      etapasResposta_one: 'En el embudo {{funil}} hay {{count}} negociación en curso:',
      etapasResposta_other: 'En el embudo {{funil}} hay {{count}} negociaciones en curso:',
      abrirQuadro: 'Abrir Comercial',
      resultado: '¿Cuántas negociaciones se crearon, vendieron y perdieron?',
      resultadoResposta: 'Resumen de las negociaciones:',
      criadas: 'Creadas',
      emAndamento: 'En curso',
      vendidas: 'Vendidas',
      perdidas: 'Perdidas',
      equipe: '¿Cuál es el desempeño de cada persona del equipo de ventas?',
      equipeResposta: 'Negociaciones por responsable:',
      equipeLinha: '{{total}} negociaciones, {{ganhas}} vendidas ({{valor}})',
      semResponsavel: 'Sin responsable',
      perdas: '¿En qué etapas del embudo perdemos más negociaciones?',
      perdasResposta_one: '{{count}} negociación perdida, por la etapa en que estaba:',
      perdasResposta_other: '{{count}} negociaciones perdidas, por la etapa en que estaban:',
      perdidasN_one: '{{count}} perdida',
      perdidasN_other: '{{count}} perdidas',
      semPerdas: 'Ninguna negociación perdida hasta ahora.',
      origem: '¿Qué origen tuvo la mayor tasa de conversión?',
      origemResposta: 'El origen con la mayor tasa de venta es {{origem}}:',
      origemLinha_one: '{{taxa}} de {{count}} negociación',
      origemLinha_other: '{{taxa}} de {{count}} negociaciones',
      semDados: 'Todavía no hay negociaciones para analizar.',
      funis: '¿Cómo creo y edito mis embudos de ventas?',
      funisResposta: 'En CRM > Configuración del CRM > Embudos de ventas, usa "Crear y organizar embudos": crea un embudo nuevo (empieza con las etapas del elegido), archívalo o desarchívalo, y ajusta las etapas y el playbook de cada una.',
      abrirFunis: 'Abrir los embudos de ventas',
      motivos: '¿Dónde registro los motivos de pérdida?',
      motivosResposta: 'En CRM > Configuración del CRM > Motivos de pérdida. Aparecen al marcar una negociación como perdida.',
      abrirMotivos: 'Abrir los motivos de pérdida',
    },
  },
  funis: {
    funil: 'Embudo',
    gerir: 'Embudos',
    titulo: 'Embudos del pipeline',
    ajuda: 'Cada embudo tiene sus propias etapas. El embudo nuevo empieza con las etapas del embudo elegido; renombra, crea y elimina etapas en Admin > Configuración > Etapas y funciones y cambia el orden arrastrando las columnas en el tablero.',
    nomeNovo: 'Nombre del embudo nuevo',
    copiarDe: 'Etapas de',
    criar: 'Crear embudo',
    vazio: 'Aún no hay embudos.',
    vazioQuadro: 'Aún no hay un embudo de ventas. Crea el primero para registrar oportunidades.',
    padrao: 'Predeterminado',
    arquivado: 'Archivado',
    arquivar: 'Archivar',
    desarquivar: 'Desarchivar',
    etapas_one: '{{count}} etapa',
    etapas_other: '{{count}} etapas',
    abertas_one: '{{count}} abierta',
    abertas_other: '{{count}} abiertas',
    confirmarArquivar: '¿Archivar este embudo?',
    confirmarArquivarTexto: 'Sale de la elección de embudo y no recibe oportunidades nuevas. Las cerradas siguen en los informes; desarchívalo cuando quieras.',
  },
};

export const i18n = { pt, en, es };
